import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { ACCOUNT_SECURITY_BAN_STATUS } from '../constants';

import LeftPanel from './home/LeftPanel';
import MainPanel from './home/MainPanel';

class Home extends React.Component {
	componentWillMount() {
		if (this.props.userInfo.status & ACCOUNT_SECURITY_BAN_STATUS) {
			browserHistory.push('/unlock/index');
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.userInfo.status & ACCOUNT_SECURITY_BAN_STATUS) {
			browserHistory.push('/unlock/index');
		}
	}
	
	render() {
		return (
			<div className="main">
				<LeftPanel />
				<MainPanel />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./app/components/Home.js